var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("b-overlay", { attrs: { show: _vm.is_load } }, [
        _vm.is_data_loaded
          ? _c(
              "div",
              [
                _c("info_field", {
                  attrs: {
                    f_uniq: "cid1",
                    f_type: "station_id",
                    is_disabled: false,
                    f_title: _vm.__t("STATION_ID"),
                    f_val: _vm.rest_params.station_id.toString(),
                  },
                  on: { update_categ: _vm.change_atr },
                }),
                _vm._v(" "),
                _c("info_field", {
                  attrs: {
                    f_uniq: "cid2",
                    f_type: "table_id",
                    is_disabled: false,
                    f_title: _vm.__t("TABLE_ID"),
                    f_val: _vm.rest_params.table_id.toString(),
                  },
                  on: { update_categ: _vm.change_atr },
                }),
                _vm._v(" "),
                _c("info_field", {
                  attrs: {
                    f_uniq: "cid02",
                    f_type: "url",
                    is_disabled: false,
                    f_title: _vm.__t("URL"),
                    f_val: _vm.rest_params.url.toString(),
                  },
                  on: { update_categ: _vm.change_atr },
                }),
                _vm._v(" "),
                _c("info_field", {
                  attrs: {
                    f_uniq: "cid03",
                    f_type: "discount_id",
                    is_disabled: false,
                    f_title: _vm.__t("DISCOUNT_ID"),
                    f_val: _vm.rest_params.discount_id.toString(),
                  },
                  on: { update_categ: _vm.change_atr },
                }),
                _vm._v(" "),
                _c("info_field", {
                  attrs: {
                    f_uniq: "ci3",
                    f_title: _vm.__t("AUTHOR_ID"),
                    f_val: _vm.rest_params.author_id.toString(),
                  },
                  on: { update_categ: _vm.change_atr },
                }),
                _vm._v(" "),
                _c("info_field", {
                  attrs: {
                    f_uniq: "cid4",
                    f_title: _vm.__t("WAITER_ID"),
                    f_val: _vm.rest_params.waiter_id.toString(),
                  },
                  on: { update_categ: _vm.change_atr },
                }),
                _vm._v(" "),
                _c("info_field", {
                  attrs: {
                    f_uniq: "cid5",
                    f_title: _vm.__t("CREATOR_ID"),
                    f_val: _vm.rest_params.creator_id.toString(),
                  },
                  on: { update_categ: _vm.change_atr },
                }),
              ],
              1
            )
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }